// Core
import { isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Component, HostListener, Inject, OnDestroy, PLATFORM_ID, Input } from '@angular/core';
import { RouterLink } from '@angular/router';

// Environemnt Variables
import { environment } from '../../../../../../../environments/environment';

@Component({
    selector: 'app-navbar',
    imports: [RouterLink],
    templateUrl: './navbar.html',
    styleUrl: './navbar.scss',
})
export class Navbar implements AfterViewInit, OnDestroy {

    @Input() includeCenterLinks: boolean = false;

    environment = environment;
    activeSectionId = 'index-masterhead-section';

    private readonly sectionLinks = [
        { label: 'Home', sectionId: 'index-masterhead-section' },
        { label: 'Solutions', sectionId: 'index-about-section' },
        { label: 'Services', sectionId: 'index-services-section' },
        { label: 'Pricing', sectionId: 'index-pricing-section' },
        { label: 'Resources', sectionId: 'index-newsletter-section' },
        { label: 'Company', sectionId: 'index-ceo-section' },
    ];
    private updateTimeout?: ReturnType<typeof setTimeout>;

    constructor(@Inject(PLATFORM_ID) private platformId: object) {}

    get navLinks() {
        return this.sectionLinks;
    }

    ngAfterViewInit(): void {
        if (!this.isBrowser) {
            return;
        }

        this.updateTimeout = setTimeout(() => this.updateActiveSection());
    }

    ngOnDestroy(): void {
        if (this.updateTimeout) {
            clearTimeout(this.updateTimeout);
        }
    }

    @HostListener('window:scroll')
    onWindowScroll(): void {
        this.updateActiveSection();
    }

    @HostListener('window:resize')
    onWindowResize(): void {
        this.updateActiveSection();
    }

    scrollToSection(sectionId: string, event: Event): void {
        event.preventDefault();

        if (!this.isBrowser) {
            return;
        }

        const section = document.getElementById(sectionId);

        if (!section) {
            return;
        }

        this.activeSectionId = sectionId;

        window.scrollTo({
            top: this.getSectionScrollTop(section),
            behavior: 'smooth',
        });

        window.history.replaceState(null, '', `#${sectionId}`);
    }

    isActiveSection(sectionId: string): boolean {
        return this.activeSectionId === sectionId;
    }

    private updateActiveSection(): void {
        if (!this.isBrowser) {
            return;
        }

        const activationLine = window.scrollY + this.getNavbarOffset() + 32;
        let activeSectionId = this.sectionLinks[0].sectionId;

        for (let index = this.sectionLinks.length - 1; index >= 0; index--) {
            const { sectionId } = this.sectionLinks[index];
            const section = document.getElementById(sectionId);

            if (section && section.offsetTop <= activationLine) {
                activeSectionId = sectionId;
                break;
            }
        }

        this.activeSectionId = activeSectionId;
    }

    private getSectionScrollTop(section: HTMLElement): number {
        return section.getBoundingClientRect().top + window.scrollY - this.getNavbarOffset() - 16;
    }

    private getNavbarOffset(): number {
        return document.getElementById('index-navbar-nav')?.offsetHeight ?? 0;
    }

    private get isBrowser(): boolean {
        return isPlatformBrowser(this.platformId);
    }
}
